import * as yup from 'yup';

const limitFieldSchema = yup
  .number()
  .transform((value, originalValue) => {
    if (originalValue === '' || originalValue == null) {
      return null;
    }

    return value;
  })
  .nullable()
  .optional();

export const PlansValidationSchema = yup.object({
  name: yup
    .string()
    .required('Name is required!')
    .min(2, 'First Name must contain at least 2 characters'),
  externalProductId: yup
    .number()
    .transform((value, originalValue) => {
      if (originalValue === '' || originalValue == null) {
        return undefined;
      }

      return value;
    })
    .typeError('PayKickstart Product ID is required!')
    .required('PayKickstart Product ID is required!'),
  amount: yup.number().required('Display amount is required!'),
  recurring: yup.string().required('Billing Period is required!'),
  trialDays: yup
    .number()
    .transform((value, originalValue) => {
      if (originalValue === '' || originalValue == null) {
        return 0;
      }

      return value;
    })
    .min(0, 'Trial days cannot be negative')
    .required('Trial days is required!'),
  ofProjects: limitFieldSchema,
  ofUsers: limitFieldSchema,
});
